module.exports = __webpack_public_path__ + "static/media/hero-red.5f924c47.png";